import React, { useState, useEffect, useRef } from 'react';
import './ChatPage.css';
import { apiGet, apiPost, apiDelete, apiPostFormData } from "./apiClient";
import { useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const ChatPage = ({ user }) => {
    const navigate = useNavigate();
    const [messages, setMessages] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const [preferences, setPreferences] = useState(null);
    const [chats, setChats] = useState([]);
    const [activeChatId, setActiveChatId] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    /// Add image module //////////////////////////////////////////
    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreviewUrl, setImagePreviewUrl] = useState(null);

    const fileInputRef = useRef(null);

    const chatContainerRef = useRef(null);




    useEffect(() => {
        if (!selectedImage) {
            setImagePreviewUrl(null);
            return;
        }
        const url = URL.createObjectURL(selectedImage);
        setImagePreviewUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [selectedImage]);


    useEffect(() => {
        if (!user) navigate("/");
    }, [user, navigate]);

    // Load chat list on mount; create a first chat if none exist
    useEffect(() => {
        if (!user) return;
        const loadChats = async () => {
            try {
                let list = await apiGet("/chats/");
                if (list.length === 0) {
                    const c = await apiPost("/chats/");
                    list = [c];
                }
                setChats(list);
                setActiveChatId(list[0].id);
            } catch (error) {
                console.error("خطا در بارگذاری گفتگوها:", error);
            }
        };
        loadChats();
    }, [user]);

    // Load messages whenever the active chat changes
    useEffect(() => {
        if (!user || !activeChatId) return;
        const loadHistory = async () => {
            try {
                const data = await apiGet(`/messages/?chat_id=${activeChatId}`);
                setMessages(data);
            } catch (error) {
                console.error("خطا در بارگذاری پیام‌ها:", error);
            }
        };
        loadHistory();
    }, [user, activeChatId]);

    useEffect(() => {
        if (!user) return;
        const fetchPreferences = async () => {
            try {
                const data = await apiGet("/preferences/");
                if (data) setPreferences(data);
            } catch (error) {
                console.warn("ترجیحاتی یافت نشد:", error);
            }
        };
        fetchPreferences();
    }, [user]);

    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTo({
                top: chatContainerRef.current.scrollHeight,
                behavior: 'smooth'
            });
        }
    }, [messages, isTyping]);

    if (user === null) return <p>در حال بارگذاری...</p>;

    const isMostlyPersian = (text) => {
        const persianChars = text.match(/[\u0600-\u06FF]/g) || [];
        const nonPersianChars = text.match(/[a-zA-Z]/g) || [];
        return persianChars.length > nonPersianChars.length;
    };

    const cleanText = (text) => {
        if (typeof text !== "string") return "";
        return text
            .replace(/\n{3,}/g, "\n\n")
            .trim();
    };

    const refreshChats = async () => {
        try {
            setChats(await apiGet("/chats/"));
        } catch (error) {
            console.error("خطا در به‌روزرسانی گفتگوها:", error);
        }
    };

    const handleNewChat = async () => {
        try {
            const c = await apiPost("/chats/");
            setChats(prev => [c, ...prev]);
            setActiveChatId(c.id);
            setMessages([]);
            setSidebarOpen(false);
        } catch (error) {
            console.error("خطا در ساخت گفتگوی جدید:", error);
        }
    };

    const handleDeleteChat = async (id) => {
        const ok = window.confirm("این گفتگو و همه پیام‌های آن حذف شود؟");
        if (!ok) return;
        try {
            await apiDelete(`/chats/${id}`);
            const remaining = chats.filter(c => c.id !== id);
            setChats(remaining);
            if (activeChatId === id) {
                if (remaining.length > 0) {
                    setActiveChatId(remaining[0].id);
                } else {
                    const c = await apiPost("/chats/");
                    setChats([c]);
                    setActiveChatId(c.id);
                    setMessages([]);
                }
            }
        } catch (error) {
            console.error("خطا در حذف گفتگو:", error);
        }
    };

    const handleSelectChat = (id) => {
        if (id !== activeChatId) setActiveChatId(id);
        setSidebarOpen(false);
    };

    // const handleSendMessage = async () => {
    //     if (loading || !inputValue.trim() || !activeChatId) return;
    //     const messageText = inputValue.trim();
    //     const isFirstMessage = messages.length === 0;
    //     setInputValue('');
    //     setLoading(true);
    //     setIsTyping(true);

    //     const userMessage = {
    //         text: messageText,
    //         isClient: true,
    //         is_error: false,
    //         timestamp: new Date().toISOString(),
    //     };
    //     setMessages(prev => [...prev, userMessage]);

    //     try {
    //         const result = await apiPost("/messages/", {
    //             text: messageText,
    //             chat_id: activeChatId,
    //             is_client: true,
    //             is_error: false
    //         });
    //         const botMessage = {
    //             text: result.bot_response,
    //             isClient: false,
    //             is_error: false,
    //             timestamp: new Date().toISOString(),
    //         };
    //         setMessages(prev => [...prev, botMessage]);
    //         if (isFirstMessage) refreshChats(); // pick up auto-generated title
    //     } catch (error) {
    //         console.error('خطا در ارتباط با سرور:', error);
    //         const errorMessage = {
    //             text: "خطا در ارتباط با دستیار، لطفاً دوباره امتحان کنید.",
    //             isClient: false,
    //             is_error: true,
    //             timestamp: new Date().toISOString(),
    //         };
    //         setMessages(prev => [...prev, errorMessage]);
    //         try {
    //             await apiPost("/messages/errors", {
    //                 error_message: error.message || "Unknown error",
    //                 error_stack: JSON.stringify(error),
    //             });
    //         } catch (dbError) {
    //             console.error("خطا در ذخیره اطلاعات خطا:", dbError);
    //         }
    //     } finally {
    //         setLoading(false);
    //         setIsTyping(false);
    //     }
    // };



    const handleSendMessage = async () => {
        if (loading || (!inputValue.trim() && !selectedImage) || !activeChatId) return;
        const messageText = inputValue.trim();
        const isFirstMessage = messages.length === 0;
        const imageToSend = selectedImage;

        setInputValue('');
        setSelectedImage(null); // clear immediately so preview doesn't linger
        setLoading(true);
        setIsTyping(true);

        const userMessage = {
            text: messageText,
            image_url: imageToSend ? URL.createObjectURL(imageToSend) : null, // local-only preview
            isClient: true,
            is_error: false,
            timestamp: new Date().toISOString(),
        };
        setMessages(prev => [...prev, userMessage]);

        try {
            const formData = new FormData();
            formData.append("text", messageText);
            formData.append("chat_id", activeChatId);
            formData.append("is_client", true);
            formData.append("is_error", false);
            if (imageToSend) {
                formData.append("image", imageToSend);
            }
            const result = await apiPostFormData("/messages/", formData);


            const botMessage = {
                text: result.bot_response,
                isClient: false,
                is_error: false,
                timestamp: new Date().toISOString(),
            };
            setMessages(prev => [...prev, botMessage]);
            if (isFirstMessage) refreshChats();
        } catch (error) {
            console.error('خطا در ارتباط با سرور:', error);
            setMessages(prev => [...prev, {
                text: "⚠️ خطا در ارتباط با دستیار، لطفاً دوباره امتحان کنید.",
                isClient: false,
                is_error: true,
                timestamp: new Date().toISOString(),
            }]);
        } finally {
            setLoading(false);
            setIsTyping(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };

    const handleLogout = () => {
        const confirmExit = window.confirm("آیا مطمئن هستید که می‌خواهید خارج شوید؟");
        if (confirmExit) {
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            window.location.href = "/";
        }
    };

    return (
        <div className="chat-page-container">
            <button className="sidebar-toggle" onClick={() => setSidebarOpen(o => !o)}>☰</button>

            <div className={`chat-sidebar ${sidebarOpen ? "open" : ""}`}>
                <button className="new-chat-button" onClick={handleNewChat}>+ گفتگوی جدید</button>
                <div className="chat-list">
                    {chats.map(c => (
                        <div
                            key={c.id}
                            className={`chat-list-item ${c.id === activeChatId ? "active" : ""}`}
                            onClick={() => handleSelectChat(c.id)}
                        >
                            <span className="chat-title">{c.title}</span>
                            <button
                                className="delete-chat"
                                title="حذف گفتگو"
                                onClick={(e) => { e.stopPropagation(); handleDeleteChat(c.id); }}
                            >✕</button>
                        </div>
                    ))}
                </div>
            </div>

            <div className="chat-main">
                <div className="chat-header">
                    <button onClick={handleLogout} className="logout-button">
                        <img src="/images/logout-icon.png" alt="خروج" />
                    </button>
                    <button onClick={() => navigate("/questionnaire")} className="preferences-button">
                        <img src="/images/settings.png" alt="ترجیحات" />
                    </button>
                    <h1 className="title rtl">
                        راهنمای دوپینگ
                        <img src="/logo.png" alt="لوگو" className="inline-logo" />
                    </h1>
                </div>

                <div id="chat-container" className="chat-container" ref={chatContainerRef}>
                    {messages.map((message, index) => (
                        <div
                            key={message.id || index}
                            className={`message-container ${message.isClient ? 'client' : 'server'}`}
                        >
                            {!message.isClient && (
                                <img src="/images/bot-avatar.png" alt="Bot" className="avatar bot-avatar" />
                            )}
                            <div className={`chat-bubble ${message.isClient ? 'client-message' : 'server-message'} ${isMostlyPersian(message.text || "") ? 'rtl' : 'ltr'}`}>
                                {message.image_url && (
                                    <img src={message.image_url} alt="پیوست" className="message-attached-image" />
                                )}
                                {message.text && (
                                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                        {cleanText(message.text)}
                                    </ReactMarkdown>
                                )}
                            </div>
                            {message.isClient && (
                                <img
                                    src={
                                        preferences?.user_gender === "مرد"
                                            ? "/images/male-user-avatar.png"
                                            : preferences?.user_gender === "زن"
                                                ? "/images/female-user-avatar.png"
                                                : "/images/user-avatar.png"
                                    }
                                    alt="User"
                                    className="avatar user-avatar"
                                />
                            )}
                        </div>
                    ))}

                    {isTyping && (
                        <div className="message-container server">
                            <img src="/images/bot-avatar.png" alt="Bot" className="avatar bot-avatar" />
                            <div className="chat-bubble server-message typing-indicator">
                                <span></span><span></span><span></span>
                            </div>
                        </div>
                    )}
                </div>

                {/* <div className="input-container">
                    <textarea
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="سوال خود درباره مواد ممنوعه یا قوانین دوپینگ را بنویسید..."
                        className="rtl-input"
                        rows="3"
                        style={{ resize: "none", width: "100%" }}
                    />
                    <button onClick={handleSendMessage} disabled={loading} className="send-button">
                        <img src="/images/send-icon.png" alt="ارسال" className="send-icon" />
                    </button>
                </div> */}

                <div className="input-area">

                {selectedImage && (
                    <div className="selected-image-preview">
                        <img src={imagePreviewUrl} alt="تصویر انتخاب‌شده" />
                        <button type="button" onClick={() => setSelectedImage(null)}>✕</button>
                    </div>
                )}

                <div className="input-container">

                        <input
                            type="file"
                            accept="image/*"
                            ref={fileInputRef}
                            style={{ display: "none" }}
                            onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (!file) return;
                                if (!file.type.startsWith("image/")) {
                                    alert("لطفاً یک فایل تصویری انتخاب کنید.");
                                    return;
                                }
                                if (file.size > 5 * 1024 * 1024) {
                                    alert("حجم تصویر باید کمتر از ۵ مگابایت باشد.");
                                    return;
                                }
                                setSelectedImage(file);
                                e.target.value = ""; // allows re-selecting the same file later
                            }}
                        />

                        <button
                            type="button"
                            className="image-upload-button"
                            onClick={() => fileInputRef.current?.click()}
                            disabled={loading}
                            title="افزودن تصویر"
                        >
                            📷
                        </button>

                        <textarea
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder="سوال خود درباره مواد ممنوعه یا قوانین دوپینگ را بنویسید..."
                            className="rtl-input"
                            rows="3"
                        />

                        <button
                            type="button"
                            onClick={handleSendMessage}
                            disabled={loading || (!inputValue.trim() && !selectedImage)}
                            className="send-button"
                        >
                            <img
                                src="/images/send-icon.png"
                                alt="ارسال"
                                className="send-icon"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatPage;
